import noop from 'utils/noop';
import { assign, create } from 'utils/object';

export const extern = {};

export default function getblcktiveContext(blcktive, ...assigns) {
  const fragment =
    blcktive.fragment ||
    blcktive._fakeFragment ||
    (blcktive._fakeFragment = new FakeFragment(blcktive));
  return fragment.getContext.apply(fragment, assigns);
}

export function getContext(...assigns) {
  if (!this.ctx) this.ctx = new extern.Context(this);
  assigns.unshift(create(this.ctx));
  return assign.apply(null, assigns);
}

export class FakeFragment {
  constructor(blcktive) {
    this.blcktive = blcktive;
  }

  findContext() {
    return this.blcktive.viewmodel;
  }
}
const proto = FakeFragment.prototype;
proto.getContext = getContext;
proto.find = proto.findComponent = proto.findAll = proto.findAllComponents = noop;

export function findParentWithContext(fragment) {
  let frag = fragment;
  while (frag && !frag.context) frag = frag.parent;
  if (!frag) return fragment && fragment.blcktive.fragment;
  else return frag;
}
